(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ign-data", [], factory);
	else if(typeof exports === 'object')
		exports["ign-data"] = factory();
	else
		root["ign-data"] = factory();
})(self, function() {
return 